function cov_1m4ayordkx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight.tsx";
  var hash = "8bc5d27d1b71da2697b9377c2e1daa79b0844106";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8bc5d27d1b71da2697b9377c2e1daa79b0844106"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1m4ayordkx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1m4ayordkx();
var Icon = (cov_1m4ayordkx().s[0]++, {
  name: 'chevron-right',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.08623 4.14711C7.55727 3.64242 8.34826 3.61514 8.85294 4.08619L16.3529 11.0862C16.6184 11.3339 16.763 11.6848 16.7491 12.0476C16.7353 12.4104 16.5644 12.7493 16.2809 12.9761L8.78091 18.9761C8.24184 19.4074 7.45522 19.32 7.02396 18.7809C6.5927 18.2418 6.6801 17.4552 7.21918 17.0239L13.5901 11.9272L7.14715 5.91382C6.64246 5.44278 6.61518 4.6518 7.08623 4.14711Z\" fill=\"currentColor\"/>"
});
export default Icon;